import { forwardRef, useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../../../shared/components/button/Button";
import { FileUp } from "lucide-react";
import BulkLoadObjectiveTrackerForm from "./BulkLoadObjectiveTrackerForm";
import useAuthentication from "../../../../../../hooks/useAuthentication";

const BulkLoadObjectiveTrackerDialog = ({ onSubmitHandler, clients }) => {
  const auth = useAuthentication();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    const values = { ...formValues, createdBy: auth.userLogged().fullname };
    onSubmitHandler(values);
    setIsOpen(false);
  };

  const ButtonTrigger = forwardRef((props, ref) => {
    return (
      <Button {...props} className="h-7 gap-1" ref={ref}>
        <span className="sr-only sm:not-sr-only sm:whitespace-nowrap">
          {t("objectivesTracker.bulkLoad.trigger")}
        </span>
        <FileUp className="sm:hidden" />
      </Button>
    );
  });

  return (
    <DialogFormPanel
      trigger={<ButtonTrigger />}
      title="Title here"
      description="Description here"
      content={
        <BulkLoadObjectiveTrackerForm
          onSubmitHandler={onSubmit}
          clients={clients}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default BulkLoadObjectiveTrackerDialog;
